export default {
  Form_Tips_Common: {
    enter_clinc_name: '請輸入診所名稱',
    enter_clinc_code: '請輸入診所編碼',
    enter_details_address: '請輸入詳細地址',
    enter_phone: '請輸入電話',
    select_administrator: '請選擇管理員',
    letter_letters_numbers: '以字母開頭，大小寫字母、數字及「-」之組合',
    QingShuRu_JingZhong: '請輸入淨重(如:200g)',
    XiuGai_MiMa_GuiZe: '*必須包含數字，大寫字母，小寫字母，特殊字符的任意三種組合並且長度為6~16',
    enter_project_name: '請輸入項目名稱',
    enter_project_price: '請輸入項目價格',
    enter_project_duration: '請輸入項目時長',
    enter_role_name: '請輸入角色名',
    select_clinic_codes: '請選擇診所',
    select_data_scope: '請選擇權限範圍',
    enter_product_name: '請输入商品名稱',
    enter_product_price: '請輸入商品價格',
    enter_new_password: '請輸入新密碼',
    enter_old_password: '請輸入原密碼',
    enter_new_account: '請輸入新賬號',
    enter_new_nickname: '請輸入新暱稱',
    enter_new_en_name: '請輸入新英文名',
    password_format_error: '密碼格式錯誤',
    password_length_tip: '密碼長度為6~16位',
    enter_keyword: '請輸入名稱或編碼',
    enter_name: '請輸入名稱',
    enter_code: '請輸入編碼',
    enter_org_code: '請輸入組織編碼',
    enter_org_name: '請輸入組織名稱',
    enter_batch_number: '請輸入批號',
    enter_domain: '請輸入域名',
    un_available_option: '無可用選項',
    enter_password: '請輸入密碼',
    select_zhu_huanzhe: '請選擇主患者',
    select_dai_hebing: '請選擇待合併患者',
    select_org: '請選擇組織',
    enter_secret_name: '請輸入秘鑰名稱',
  },
}
